import { cn } from '@eliadmin/core/src/utils/style-utils';

/** Figma "Star" (rating/star filled, 20 px grid, corner radius 1.25). */
export const STAR_PATH =
  'M8.879 2.271C9.338 1.342 10.662 1.342 11.121 2.271L12.648 5.366C12.83 5.735 13.182 5.99 13.589 6.049L17.004 6.546C18.029 6.695 18.439 7.955 17.697 8.678L15.226 11.086C14.931 11.374 14.797 11.787 14.866 12.193L15.45 15.594C15.625 16.615 14.553 17.394 13.636 16.912L10.582 15.306C10.218 15.114 9.782 15.114 9.418 15.306L6.364 16.912C5.447 17.394 4.375 16.615 4.55 15.594L5.134 12.193C5.203 11.787 5.069 11.374 4.774 11.086L2.303 8.678C1.561 7.955 1.971 6.695 2.996 6.546L6.411 6.049C6.818 5.99 7.17 5.735 7.352 5.366L8.879 2.271Z';

const SIZES = { sm: 'size-[18px]', md: 'size-5', lg: 'size-8' } as const;

export type StarSize = keyof typeof SIZES;

export function StarShape({ size, className }: { size: StarSize; className?: string }) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      className={cn(SIZES[size], className)}
    >
      <path d={STAR_PATH} />
    </svg>
  );
}

/** Five stars, `value` of them filled (icon/rating on bg/muted); read as one image. */
export function RatingStars({
  value,
  size = 'md',
  label,
  className,
}: {
  value: number;
  size?: StarSize;
  /** Accessible name of the whole rating, e.g. „Hodnotenie 4 z 5“. */
  label: string;
  className?: string;
}) {
  return (
    <span role="img" aria-label={label} className={cn('flex gap-0.5', className)}>
      {[1, 2, 3, 4, 5].map(star => (
        <StarShape
          key={star}
          size={size}
          className={star <= Math.round(value) ? 'text-[#E89A0C]' : 'text-[#E2E4E7]'}
        />
      ))}
    </span>
  );
}
